import { useEffect } from 'react';
import triggerGoogleTagManagerCustomEvent from '../../common/utils/triggerGoogleTagManagerCustomEvent';
import GtmEvents from '../constants/gtmEvents';
import findAssociatedLabel from '../utils/findAssociatedLabel';

function useGtmRadioButtonTracking() {
  useEffect(() => {
    const handleChange = (e: Event) => {
      if (!(e.target instanceof HTMLInputElement)) {
        return;
      }
      if (e.target.type !== 'radio') {
        return;
      }

      const label = findAssociatedLabel(e.target);
      triggerGoogleTagManagerCustomEvent(GtmEvents.RADIOBUTTON_CLICK, {
        label,
        new_state: e.target.checked ? 'enabled' : 'disabled',
      });
    };

    document.addEventListener('change', handleChange, { capture: true });
    return () => document.removeEventListener('change', handleChange, { capture: true });
  }, []);
}

export default useGtmRadioButtonTracking;
